import { createFileRoute } from '@tanstack/react-router';

import { inventoryReportQueryOptions, InventoryReportPage } from '@/features/reports';

export const Route = createFileRoute('/_authed/_active/s/$storeId/reports/inventory')({
  staticData: { crumb: 'reports:tabs.inventory', tours: ['reports.inventory'] },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...inventoryReportQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: InventoryReportPage,
});
